// api
import { fetchApi } from '@/api'
// actions
const papeleriaEnlistmentAll = (context) => {
  let url = 'papeleria/enlistment'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_ENLISTMENT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaEnlistmentForm = (context) => {
  let url = 'papeleria/enlistment/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_ENLISTMENT_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaEnlistmentShow = (context) => {
  let url = 'papeleria/enlistment'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_ENLISTMENT_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const papeleriaEnlistmentCreate = (context) => {
  let url = 'papeleria/enlistment/create'
  let data = {}
  return fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_ENLISTMENT_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaEnlistmentUpdate = (context) => {
  let url = 'papeleria/enlistment'
  let data = {}
  return fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_ENLISTMENT_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaEnlistmentDelete = (context, payload) => {
  let url = 'papeleria/enlistment'
  console.log(payload)
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_ENLISTMENT_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  papeleriaEnlistmentAll,
  papeleriaEnlistmentForm,
  papeleriaEnlistmentShow,
  papeleriaEnlistmentCreate,
  papeleriaEnlistmentUpdate,
  papeleriaEnlistmentDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/enlistment/actions.js